import { metrics } from '@seek/metrics-js';
import { Box, useThemeName } from 'braid-design-system';
import React, { Fragment, useEffect } from 'react';

import { FooterContainer } from 'src/components/HeaderFooter/FooterContainer';
import { HeaderContainer } from 'src/components/HeaderFooter/HeaderContainer';
import { CreateResume } from 'src/components/Profile/CreateResume/CreateResume';
import { Profile } from 'src/components/Profile/Profile';
import { ProfileLoadError } from 'src/components/Profile/ProfileLoadError/ProfileLoadError';
import { ShareableProfile } from 'src/components/Profile/ShareableProfile/ShareableProfile';
import { useCandidateId } from 'src/components/Profile/data';
import { configureTrackJs } from 'src/modules/error-logger';
import { useTypedSelector } from 'src/modules/hooks/useTypedSelector';
import { useWindowHistory } from 'src/modules/hooks/useWindowHistory';

import { InfoBanner } from './InfoBanner';
import { useGetUserDetails } from './analytics';

const SetComputedTheme = () => {
  const computedTheme = useThemeName();

  useEffect(() => {
    window.APP_CONFIG.theme = computedTheme;
  }, [computedTheme]);

  return <></>;
};

const ProfileApp = () => {
  const profileLoadError = useTypedSelector(
    ({ profile }) => profile.profileLoadError,
  );
  const profileAuthError = useTypedSelector(
    ({ profile }) => profile.profileAuthError,
  );

  const page = useTypedSelector((state) => state.router.page);

  const showCreateResume = page === 'create-resume-page';

  const { candidateId } = useCandidateId();

  useEffect(() => metrics.count('first-render'), []);

  useEffect(() => {
    if (candidateId) {
      configureTrackJs(candidateId);
    }
  }, [candidateId]);

  useGetUserDetails();

  return (
    <>
      <HeaderContainer />
      {profileLoadError && !profileAuthError ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="spaceBetween"
          style={{ minHeight: '90vh' }}
        >
          <ProfileLoadError />
          <FooterContainer />
        </Box>
      ) : (
        <Fragment>
          <SetComputedTheme />
          {showCreateResume ? <CreateResume /> : <Profile />}
          <FooterContainer />
        </Fragment>
      )}
    </>
  );
};

export const App = () => {
  useWindowHistory();
  const page = useTypedSelector((state) => state.router.page);

  useEffect(() => {
    if (page === 'shareable-profile-page') {
      configureTrackJs('ShareableProfileViewer');
    }
  }, [page]);

  return (
    <>
      <InfoBanner />
      {page === 'shareable-profile-page' ? (
        <ShareableProfile />
      ) : (
        <ProfileApp />
      )}
    </>
  );
};
